var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLoginIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.987,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8134 1.59112C11.9009 1.46962 12.5444 1.46962 13.7129 1.59112C15.7813 1.89727 17.6987 2.85335 19.1879 4.32113C18.1816 5.27233 17.1885 6.23742 16.2089 7.21612C14.3329 5.62612 12.2389 5.25912 9.92688 6.11513C8.23088 6.89512 7.04988 8.15913 6.38388 9.90713C5.29554 9.09687 4.22137 8.26774 3.16188 7.42013C3.08824 7.38137 3.00415 7.36718 2.92188 7.37962C4.60488 4.13462 7.23488 2.20462 10.8119 1.58962",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91938 7.37978C3.00438 7.36678 3.08488 7.38028 3.16088 7.42028C4.22038 8.2679 5.29454 9.09703 6.38288 9.90728C6.21162 10.5884 6.10366 11.2838 6.06038 11.9848C6.09738 12.6628 6.20488 13.3283 6.38288 13.9813L3.00038 16.6738C1.52738 13.5958 1.50038 10.4978 2.91938 7.37978Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0281 19.9341C17.9749 19.0053 16.8723 18.134 15.7251 17.3241C16.8751 16.5121 17.5731 15.3981 17.8191 13.9821H12.1836V10.0686C15.4336 10.0416 18.6821 10.0691 21.9291 10.1511C22.5451 13.4961 21.8336 16.5121 19.7946 19.1991C19.5521 19.4569 19.2953 19.7022 19.0281 19.9341Z",
    fill: "#448AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3825 13.9824C7.6125 17.0394 9.8675 18.4664 13.1475 18.2634C14.0682 18.1568 14.951 17.8352 15.7245 17.3244C16.8725 18.1364 17.9735 19.0064 19.0275 19.9344C17.3575 21.4351 15.2282 22.3255 12.987 22.4604C12.4778 22.5011 11.9662 22.5011 11.457 22.4604C7.639 22.0104 4.82 20.0814 3 16.6734L6.3825 13.9824Z",
    fill: "#43A047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLoginIcon);
export default __webpack_public_path__ + "static/media/googleLoginIcon.b16ae6882f7ff9abb41f2bc1dbbfba68.svg";
export { ForwardRef as ReactComponent };